import { Injectable } from '@angular/core';
import { TowAttempt } from '@models/tow-attempt.model';
import { combineLatest, Observable, switchMap } from 'rxjs';
import { DbService } from './db.service';
import { GeoService } from './geo.service';

const COLLECTION = 'towAttempts';

@Injectable({
    providedIn: 'root'
})
export class TowAttemptService {
    constructor(
        private dbService: DbService,
        private geoService: GeoService
    ) {}

    saveTowAttempt(towAttempt: TowAttempt): Observable<TowAttempt> {
        const start = towAttempt.route.start;
        const destination = towAttempt.route.destination;
        const startAddress$ = this.geoService.getAddress(start.latitude, start.longitude);
        const destinationAddress$ = this.geoService.getAddress(destination.latitude, destination.longitude);
        return combineLatest([startAddress$, destinationAddress$]).pipe(
            switchMap(([startAddress, destinationAddress]) => {
                const updatedTowAttempt: TowAttempt = {
                    ...towAttempt,
                    route: {
                        ...towAttempt.route,
                        start: { ...start,
                            geohash: startAddress.geoData?.geohash ?? '',
                            address: startAddress.formatted
                        },
                        destination: {
                            ...destination,
                            geohash: destinationAddress.geoData?.geohash ?? '',
                            address: destinationAddress.formatted
                        }
                    }
                };
                return this.dbService.saveObj(COLLECTION, updatedTowAttempt);
            })
        );
    }
}
